import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import styled, { css } from 'styled-components';
export var LoadingWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  line-height: 1;\n  color:  ", ";\n  \n  ", "\n\n  @keyframes circular-rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  };\n\n  @keyframes circular-dash {\n    0% {\n      stroke-dasharray: 1px, 200px;\n      stroke-dashoffset: 0px;\n    }\n    50% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -15px;\n    }\n    100% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -125px;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return color || theme.circularProgress.color;
}, function (_ref2) {
  var variant = _ref2.variant;
  if (variant === 'indeterminate') {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        animation: circular-rotate 1.4s linear infinite;\n      "])));
  }
  if (variant === 'static') {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      "])));
  }
  return null;
});
export var Svg = styled.svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
export var Circle = styled.circle(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  stroke: currentColor;\n\n  ", "\n"])), function (_ref3) {
  var variant = _ref3.variant;
  if (variant === 'indeterminate') {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        animation: circular-dash 1.4s ease-in-out infinite;\n        stroke-dasharray: 80px, 200px;\n        stroke-dashoffset: 0px;\n      "])));
  }
  if (variant === 'static') {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        transition: stroke-dashoffset 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      "])));
  }
  return null;
});